import { Pipe, PipeTransform } from '@angular/core';
import { ShellDomainProvider } from '@ecap3/core';

@Pipe({ name: 'formatIBAN' })
export class FormatIBANPipe implements PipeTransform {
  transform(value: string): string {

    let formattedValue = "", ibanFormat=" - ";
    // by default iban key separator is " - ", for FC-CZ and FC-SK iban key separator is " "
    const customIBANFormat = ShellDomainProvider['api'].customIBANFormat;
    if(customIBANFormat){
      ibanFormat =  customIBANFormat[0];
    }

    formattedValue = value;
    let splittedValue = [];
    if (value) {
      splittedValue = value.match(/.{1,4}/g);
      formattedValue = splittedValue.join(ibanFormat);
    }
    return formattedValue;
  }
}